__turbopack_context__.v({
  "category_name": "FH5-na_category_name",
  "container": "FH5-na_container",
  "item": "FH5-na_item",
  "item_name": "FH5-na_item_name",
  "item_split": "FH5-na_item_split",
  "item_url": "FH5-na_item_url",
  "list": "FH5-na_list",
  "title": "FH5-na_title",
});
